import { useParams } from 'react-router-dom';

export default function useAlbumId() {
  const { id } = useParams();
  return Number(id!);
}
